import geolocator from 'geolocator'

export default () => {
  geolocator.config({
    language: 'en',
    google: { version: '3', key: process.env.REACT_APP_GOOGLE_API_KEY }
  })
}
